/**
 * 上传文件进度组件
 */
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
// import { Checkbox, Menu, Dropdown, Spin, Input, Pagination, message, Tooltip } from 'antd';
import './TransmissionList.scss';
import { store } from 'Store/store.index';
import intl from 'react-intl-universal';

@inject('storageAppStore')
@observer
class TransmissionList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showUploadCompleted: false,
            showUploadList: false,
        };
    }
    componentDidMount () {
        // store.storageAppStore.uploadFiles = [
        //     { id: 1, name: '1-2a_3_2007_LS_Capitolato_tecnico.pdf', status: 'error' },
        //     { id: 2, name: '2-HCIA-AI V3.0 培训教材.pdf', status: 'uploading' },
        //     // { id: 3, name: '3-2a_3_2007_LS_Capitolato_tecnico.pdf', status: 'success' },
        //     // { id: 4, name: '4-HCIA-AI V3.0 培训教材.pdf', status: 'uploading' },
        //     { id: 5, name: '5-2a_3_2007_LS_Capitolato_tecnico.pdf', status: 'uploading' },
        //     // { id: 6, name: '6-HCIA-AI V3.0 培训教材.pdf', status: 'uploading' },
        //     // { id: 7, name: '7-2a_3_2007_LS_Capitolato_tecnico.pdf', status: 'uploading' },
        //     // { id: 8, name: '8-HCIA-AI V3.0 培训教材.pdf', status: 'uploading' },
        //     // { id: 9, name: '9-2a_3_2007_LS_Capitolato_tecnico.pdf', status: 'uploading' },
        //     // { id: 10, name: '10-HCIA-AI V3.0 培训教材.pdf', status: 'uploading' },
        // ];
    }
    /**
     * 取消事件冒泡
     * @param e
     */
    cancelBubble (e) {
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
    }
    toggleUploadCompleted (toggle) {
        if (toggle !== undefined) {
            this.setState({ showUploadCompleted: toggle });
        } else {
            this.setState({ showUploadCompleted: !this.state.showUploadCompleted });
        }
    }
    toggleUploadList (toggle) {
        if (toggle !== undefined) {
            this.setState({ showUploadList: toggle });
        } else {
            this.setState({ showUploadList: !this.state.showUploadList });
        }
    }
    reUpload (data) {
        const { folderId, id, file, name } = data;
        store.storageAppStore.setUploadFile(id, name, file, folderId, 'uploading');
        file && file.arrayBuffer().then(buffer => {
            return buffer;
        }).then(buffer => {
            return store.storageAppStore.upload(folderId, buffer, name, file.type, () => {
                store.storageAppStore.setUploadFile(id, name, file, folderId, 'success');
                this.props.onReuploadSuccess && this.props.onReuploadSuccess();
            }, id).then(()=>{}, ()=>{
                store.storageAppStore.setUploadFile(id, name, file, folderId, 'error');
            });
        });
    }
    render () {
        const { showUploadCompleted, showUploadList } = this.state;
        const { uploadFiles } = store.storageAppStore;
        const uploadingFiles = uploadFiles.filter(item => item.status === 'uploading');

        return (
            <button className='wc-button transmission' onClick={()=>{this.toggleUploadCompleted()}}>
                <a className={`wc-icon transmission${uploadFiles.length?' point':''}`}></a>
                {intl.get('FoxitStorage.UploadFiles.Title')}
                {
                    showUploadCompleted && 
                    <div className='upload-completed' onClick={e=>this.cancelBubble(e)}>
                        <header>
                            <span>{intl.get('FoxitStorage.UploadFiles.Title')}（{uploadingFiles.length}/{uploadFiles.length}）</span>
                            <div>
                                <a className={`wc-icon ${showUploadList?'arrow':'arrow down'}`} onClick={()=>this.toggleUploadList()}></a>
                                <a className='wc-icon close' onClick={()=>this.toggleUploadCompleted(false)}></a>
                            </div>
                        </header>
                        {/* <div className='progress' style={{width: '50%'}}></div> */}
                        {
                            showUploadList && 
                            <ul className='uploading-tips'>
                                {
                                    uploadFiles.map((item) => 
                                        <li key={item.id||item.name}>
                                            
                                            {
                                                item.status === 'error' && <>{intl.get('FoxitStorage.UploadFiles.UploadFailed')}<span>{item.name}</span><a className='wc-icon reload' onClick={()=>this.reUpload(item)}></a></>
                                            }
                                            {
                                                item.status === 'success' && <>{intl.get('FoxitStorage.UploadFiles.Success')}<span>{item.name}</span><a className='wc-icon load-success'></a></>
                                            }
                                            {
                                                item.status === 'uploading' && <>{intl.get('FoxitStorage.UploadFiles.Uploading')}<span>{item.name}</span><a className='wc-icon load spin'></a></>
                                            }
                                        </li>
                                    )
                                }
                            </ul>
                        }
                    </div>
                }
                
            </button>
        );
    }
}
export default TransmissionList;
